import { render, staticRenderFns } from "./CreateOrder.vue?vue&type=template&id=1be48864&scoped=true"
import script from "./CreateOrder.vue?vue&type=script&lang=js"
export * from "./CreateOrder.vue?vue&type=script&lang=js"
import style0 from "../assets/styles-new/create-order.sass?vue&type=style&index=0&id=1be48864&prod&lang=sass&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be48864",
  null
  
)

export default component.exports